module.exports = __webpack_public_path__ + "media/images/redesign-images/home/home-social-share-banner-493749120067071ecc57fa8574ce5db9.jpg";